<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.30541 7.09497V12.6H7.1222V7.09497L12.6424 7.09497V6.28043L7.1222 6.28042V0.381836H6.30541V6.28042L0.390625 6.28042V7.09497L6.30541 7.09497Z"
      fill="#3F3844"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconPlus'
}
</script>
